/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/**
 * Angular service that handles general page snapshot actions.
 */
@Injectable({
  providedIn: 'root',
})
export class PageSnapshotDialogService {
  /**
   * Default Constructor.
   * @param http Http client.
   */
  constructor(private http: HttpClient) { }

  /**
   * Get snapshots of page.
   */
  getSnapshotPage(draftPageId, params): Promise< any > {
    return this.http.get(`units/${draftPageId}/snapshots`, { params }).toPromise();
  }
}
